import { makeStyles } from "@material-ui/core/styles";

/**
 * Styles for the new RAM Portal adoption modal shown to RAM Live customers
 * with the RAM_LIVE_VISIBLE feature flag enabled.
 */
export const useStyles = makeStyles(() => ({
  dialog: {
    border: "none",
    padding: 0,
    margin: "auto",
    background: "transparent",
    maxWidth: "none",
    overflow: "visible",
    "&::backdrop": {
      background: "rgba(0,0,0,.35)",
      backdropFilter: "blur(6px)",
    },
    "&[open]:not(:modal)": {
      position: "fixed",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      maxHeight: "none",
      background: "rgba(0,0,0,.35)",
      backdropFilter: "blur(6px)",
      zIndex: 9999,
    },
    "@media (max-width: 900px)": {
      margin: 0,
      padding: 12,
      boxSizing: "border-box",
      "&[open]": {
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        margin: 0,
        overflow: "auto",
        paddingTop: "max(12px, env(safe-area-inset-top))",
        paddingBottom: "max(12px, env(safe-area-inset-bottom))",
        paddingLeft: "max(12px, env(safe-area-inset-left))",
        paddingRight: "max(12px, env(safe-area-inset-right))",
      },
    },
  },
  modal: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    width: 1100,
    maxWidth: "95%",
    maxHeight: "calc(100dvh - 24px)",
    borderRadius: 28,
    boxShadow: "0 30px 80px rgba(0,0,0,.18)",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    "@media (max-width: 900px)": {
      width: "100%",
      maxWidth: "100%",
      flexShrink: 0,
      borderRadius: 20,
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    padding: 40,
    paddingBottom: 0,
    paddingRight: 0,
    overflow: "visible",
    minWidth: 0,
    "@media (max-width: 900px)": {
      flexDirection: "column",
      padding: 40,
      paddingBottom: 40,
      paddingRight: 0,
    },
  },
  text: {
    flex: 1,
    boxSizing: "border-box",
    paddingRight: 56,
    paddingTop: 14,
    "@media (max-width: 900px)": {
      flex: "0 0 auto",
    },
  },
  subtitle: {
    fontSize: 13,
    letterSpacing: 1.2,
    color: "#888",
    marginBottom: 10,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
  },
  heading: {
    fontSize: 36,
    lineHeight: 1.1,
    fontWeight: 600,
    color: "#171633",
    margin: "0 0 20px",
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    "@media (max-width: 900px)": {
      fontSize: 24,
      marginBottom: 16,
    },
  },
  highlight: {
    color: "#e5007e",
  },
  description: {
    fontSize: 18,
    lineHeight: 1.6,
    color: "#444",
    marginBottom: 28,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    fontWeight: 400,
    "@media (max-width: 900px)": {
      fontSize: 16,
    },
  },
  cta: {
    display: "inline-block",
    background: "#e5007e",
    color: "#fff",
    padding: "14px 28px",
    borderRadius: 999,
    fontSize: 18,
    fontWeight: 600,
    textDecoration: "none",
    transition: "all .2s ease",
    marginBottom: 19,
    fontFamily: '"Poppins", "DM Sans", sans-serif',
    "&:hover": {
      background: "#c7006d",
      color: "#fff",
    },
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    overflow: "hidden",
    "@media (max-width: 900px)": {
      display: "none",
    },
  },
  image: {
    width: "120%",
    maxWidth: "none",
  },
  closeButton: {
    position: "absolute",
    top: 18,
    right: 20,
    width: 36,
    height: 36,
    border: "none",
    background: "rgba(255,255,255,0.9)",
    fontSize: 22,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
    zIndex: 2,
    flexShrink: 0,
    "&:hover": {
      color: "#e5007e",
    },
  },
}));
